/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Copy_TextInputs */



/**
* | output |
* | --- |
* | "Copy as text" |
*
* @param {Deck_Copy_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_copy_text = /** @type {((inputs?: Deck_Copy_TextInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Copy_TextInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier en texte")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar como texto")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Copiar como texto")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia come testo")
	return /** @type {LocalizedString} */ ("Copy as text")
});